var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStatusProducerUsers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1517_19056)",
    stroke: "#fff",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.583 19.25v-1.833a3.667 3.667 0 0 0-3.667-3.667H4.583a3.667 3.667 0 0 0-3.666 3.667v1.833M8.25 10.083a3.667 3.667 0 1 0 0-7.333 3.667 3.667 0 0 0 0 7.333ZM21.084 19.25v-1.833a3.666 3.666 0 0 0-2.75-3.548M14.666 2.87a3.667 3.667 0 0 1 0 7.103"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1517_19056"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h22v22H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusProducerUsers);
export default __webpack_public_path__ + "static/media/status-producer-users.06b735fc950a8f2f345ae442bf3f7cdc.svg";
export { ForwardRef as ReactComponent };